import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(axios)
Vue.use(VueAxios)

export default {
  install(Vue) {
    Vue.prototype.$dharmaApplicationOrderApiService = {
      dharma_application_order_api_url: `${process.env.VUE_APP_MEMBER_API_URL}/dharma-application-orders`,
      dharma_application_order_api_token: process.env.VUE_APP_MEMBER_API_TOKEN,
      
      /**
       * 建立法寶申請資料
       * @param {*} data 
       * @returns 
       */
      async create(data) {
        // const formData = new FormData();
        // Object.keys(data).forEach(key => {
        //   if (typeof data[key] === 'object' && data[key] !== null) {
        //     if (key === 'detail' && data[key].organization_registration_photo instanceof File) {
        //       formData.append('organization_registration_photo', data[key].organization_registration_photo);
        //     }
            
        //     formData.append(key, JSON.stringify(data[key]));
        //   } else {
        //     formData.append(key, data[key]);
        //   }
        // });

        // const response = await axios.post(
        //   `${this.dharma_application_order_api_url}`,
        //   formData,
        //   {
        //     headers: {
        //       'Authorization': `Bearer ${this.dharma_application_order_api_token}`,
        //       'Content-Type': 'multipart/form-data'
        //     }
        //   }
        // );
        // console.log('response', response);
        const response = await axios.post(
          `${this.dharma_application_order_api_url}`,
          data,
          { headers: { 'Authorization': `Bearer ${this.dharma_application_order_api_token}` } }
        )
        
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null;
      }
    }
  }
}
